(function() {
  const preloader = document.getElementById('video-preloader');
  const video = document.getElementById('preloader-video');

  // Logic is now simplified: if the elements exist, the animation runs.
  if (preloader && video) {

    // Function to handle hiding the preloader
    function hidePreloader() {
      // Use display: none for instant hide on repeated visits
      preloader.classList.add('is-hidden'); 
    }

    // 1. Start the video automatically (muted is required for autoplay)
    video.play().catch(error => {
        // Autoplay failed, hide immediately
        hidePreloader();
    });

    // 2. Hide the preloader when the video finishes
    video.addEventListener('ended', hidePreloader);

    // 3. Fallback: Hide preloader after a maximum time (e.g., 5 seconds) 
    setTimeout(hidePreloader, 5000); 

  } else if (preloader) {
    // If something went wrong with the video, ensure the preloader is hidden
    preloader.style.display = 'none';
  }
})();
